import { cn } from '@uconnect/assets/lib/utils';

export default function SearchQuota( {
	remainingSearches,
	maxGuestSearches,
	signInUrl,
	isExpanded,
	onSignIn,
	containerMaxWidthClasses,
}: {
	remainingSearches: number;
	maxGuestSearches: number;
	signInUrl?: string;
	isExpanded: boolean;
	onSignIn?: () => void;
	containerMaxWidthClasses?: string;
} ) {
	const ratio = remainingSearches / maxGuestSearches;
	const useSegments = maxGuestSearches > 1;
	type QuotaState = 'full' | 'medium' | 'low' | 'empty';
	let state: QuotaState;
	switch ( true ) {
		case remainingSearches <= 0:
			state = 'empty';
			break;
		case ratio <= 0.5:
			state = 'low';
			break;
		case ratio <= 0.75:
			state = 'medium';
			break;
		default:
			state = 'full';
	}

	const containerClasses = cn(
		containerMaxWidthClasses,
		'px-5!'
	);

	const cardClasses = cn(
		'p-3! rounded-sm',
		!useSegments && 'bg-amber-50!',
		useSegments && state === 'full' && 'bg-green-50!',
		useSegments && state === 'medium' && 'bg-amber-50!',
		useSegments && state === 'low' && 'bg-red-50!',
		useSegments && state === 'empty' && 'bg-[#f6f6f6]!'
	);

	const titleClasses = cn(
		'font-semibold text-base',
		useSegments && state === 'low' && 'text-red-700',
	);

	const segmentColor = cn(
		state === 'full' && 'bg-green-500!',
		state === 'medium' && 'bg-amber-400!',
		state === 'low' && 'bg-red-700!'
	);

	if ( state === 'empty' ) {
		return (
			<div className={ containerClasses }>
				<div className={ cn( cardClasses, 'flex! flex-wrap justify-between gap-4' ) }>
					<div className="flex! flex-col gap-1">
						<span className={ titleClasses }>Daily guest limit reached.</span>
						<span className="text-sm text-muted-foreground">
							<a href={ signInUrl } className="underline! text-inherit! font-semibold" onClick={ onSignIn }>Sign in</a>
							{ ' ' }
							to continue using AI&nbsp;Search.
						</span>
						<span className="text-xs text-muted-foreground">Guest access resets at midnight.</span>
					</div>
					<a href={ signInUrl } className="button shrink-0 self-end" onClick={ onSignIn }>Sign in</a>
				</div>
			</div>
		);
	}

	return (
		<div className={ containerClasses }>
			<div className={ cn( cardClasses, 'flex! flex-col gap-2' ) }>
				<span className={ titleClasses }>
					Try AI Search in guest mode with
					{ ' ' }
					{ remainingSearches }
					{ ' ' }
					{ remainingSearches === 1 ? 'search' : 'searches' }
					{ ' ' }
					today.
				</span>
				{ useSegments
					&& (
						<div className="flex! gap-1 mt-2" aria-hidden="true">
							{ Array.from( { length: maxGuestSearches }, ( _, i ) => (
								<div
									key={ i }
									className={ cn(
										i < remainingSearches ? segmentColor : 'bg-foreground/50!',
										'h-1 rounded-full flex-1'
									) }
								/>
							) ) }
						</div>
					)
				}

				<span className="text-muted-foreground text-xs mt-2">
					<a href={ signInUrl } className="underline! text-inherit! font-semibold" onClick={ onSignIn }>Sign in</a>
					{ ' ' }
					for unlimited searches and saved history.
				</span>
			</div>
		</div>
	);
}
